import React from "react"

import BasePermissionGate, { BasePermissionGateProps } from "@/components/PermissionGate/BasePermissionGate"

const ManagerPanelGroupPermissionGate = (props: Omit<BasePermissionGateProps<"manager-panel">, "feature">) => {
	return (
		<BasePermissionGate
			{...props}
			feature="manager-panel"
		/>
	)
}

export default ManagerPanelGroupPermissionGate
